import type { Components, Theme } from "@mui/material/styles";
import { darkColors, lightColors } from "../tokens/colors.ts";
import { elevation } from "../tokens/elevation.ts";

export function getMuiButton(mode: "dark" | "light"): Components<Theme>["MuiButton"] {
  const c = mode === "dark" ? darkColors : lightColors;
  return {
    styleOverrides: {
      root: {
        textTransform: "none",
        fontWeight: 600,
        borderRadius: "0.375rem",
      },
      text: {
        color: c.primary,
      },
    },
    variants: [
      {
        props: { variant: "contained", color: "primary" },
        style: {
          background: `linear-gradient(135deg, ${c.primary} 0%, ${c.primaryContainer} 100%)`,
          color: c.onPrimary,
          border: "none",
          "&:hover": {
            background: `linear-gradient(135deg, ${c.primaryDim} 0%, ${c.primaryContainer} 100%)`,
          },
        },
      },
      {
        props: { variant: "outlined", color: "primary" },
        style: {
          backgroundColor: "transparent",
          border: elevation.ghostBorder[mode],
          color: c.primary,
          "&:hover": {
            backgroundColor: c.surfaceContainerHigh,
            border: elevation.ghostBorder[mode],
          },
        },
      },
    ],
  };
}
